import { getCountries, getCountryCallingCode, type CountryCode } from "libphonenumber-js";
import countries from "world-countries";

export type PhoneCountry = {
  code: CountryCode;
  name: string;
  flag: string;
  dialCode: string;
  searchText: string;
};

const supportedCountryCodes = new Set(getCountries());

export const phoneCountries: PhoneCountry[] = countries
  .filter((country) => supportedCountryCodes.has(country.cca2 as CountryCode))
  .map((country) => {
    const code = country.cca2 as CountryCode;
    const dialCode = `+${getCountryCallingCode(code)}`;
    const name = country.name.common;

    return {
      code,
      name,
      flag: country.flag,
      dialCode,
      searchText: `${name} ${code} ${dialCode}`.toLowerCase(),
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

export function findPhoneCountry(code: string | null | undefined) {
  if (!code) {
    return null;
  }

  const normalizedCode = code.toUpperCase();
  return phoneCountries.find((country) => country.code === normalizedCode) ?? null;
}
